
import { defineComponent, onMounted, ref, computed, onBeforeUpdate } from 'vue'
import { useStore } from '@/store/index'
import LayoutsAuth from '@/layouts/Auth.vue'
import { toArray } from '@/utils/array'

import VideoThumbnail from '@/components/VideoThumbnail.vue'
import { VideoWatchHistoryAttributes } from '@/types/models/video-watch-history'
import { dayjs } from '@/plugins/dayjs'
import VideoListDateRangePicker from '@/components/VideoListDateRangePicker.vue'
import BasePagination from '@/components/BasePagination.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import { getStartDateQuery, getEndDateQuery } from '@/types/forms/date-range-picker'

export default defineComponent({
  components: { LayoutsAuth, VideoThumbnail, VideoListDateRangePicker, BasePagination, LayoutsAuthWidth },
  setup() {
    const startDate = ref()
    const endDate = ref()
    const store = useStore()
    const watchHistories = computed((): VideoWatchHistoryAttributes[] => store.getters['video/filterWatchHistoriesByDate']())
    const pageSize = ref(16)
    const pagedList = ref([])

    const initializeDateRangePicker = () => {
      const strStartDate = getStartDateQuery()
      const strEndDate = getEndDateQuery()
      startDate.value = dayjs(strStartDate).format('YYYY/MM/DD')
      endDate.value = dayjs(strEndDate).format('YYYY/MM/DD')
    }

    onMounted(() => {
      initializeDateRangePicker()
      store.dispatch('video/fetchVideoWatchHistories')
    })

    onBeforeUpdate(() => {
      initializeDateRangePicker()
    })

    return {
      store,
      toArray,
      watchHistories,
      startDate,
      endDate,
      pageSize,
      pagedList
    }
  },
})
